import {
	TGetForeignDefaultInfoUnitResponse,
	TPayloadUpdateSuccess,
} from '@/services';
import { mergeItemUpdated } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { formatForeignDefaultInfoUnitDetail, RootState } from '..';
import {
	TForeignDefaultInfoUnitDetailStore,
	TForeignDomesticUnitListStore,
	TPayloadGetForeignDefaultInfoUnitDetailRequest,
	TPayloadGetForeignDefaultInfoUnitDetailSuccess,
	TPayloadGetForeignDomesticUnitListRequest,
	TPayloadGetForeignDomesticUnitListSuccess,
} from './foreign-default-info-unit.type';

const initialState = {
	fetching: false,
	defaultInfoUnitDetail: {} as TForeignDefaultInfoUnitDetailStore,
	domesticUnitList: [] as TForeignDomesticUnitListStore,
};

const OI1_01DefaultInfoUnitSlice = createSlice({
	initialState,
	name: 'oi1_01DefaultInfoUnit',
	reducers: {
		/**---- GET OI1_01_DEFAULT_INFO_UNIT DETAIL START ---- */
		getForeignDefaultInfoUnitDetailRequest: (
			state,
			action: PayloadAction<TPayloadGetForeignDefaultInfoUnitDetailRequest>
		) => {
			state.fetching = true;
		},
		getForeignDefaultInfoUnitDetailSuccess: (
			state,
			action: PayloadAction<TPayloadGetForeignDefaultInfoUnitDetailSuccess>
		) => {
			const { defaultInfoUnitDetail } = action.payload;
			state.fetching = false;
			state.defaultInfoUnitDetail = defaultInfoUnitDetail;
		},
		getForeignDefaultInfoUnitDetailFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET OI1_01_DEFAULT_INFO_UNIT DETAIL END ---- */

		/**---- GET FOREIGN DOMESTIC UNIT LIST START ---- */
		getForeignDomesticUnitListRequest: (
			state,
			action: PayloadAction<TPayloadGetForeignDomesticUnitListRequest>
		) => {
			state.fetching = true;
		},
		getForeignDomesticUnitListSuccess: (
			state,
			action: PayloadAction<TPayloadGetForeignDomesticUnitListSuccess>
		) => {
			const { domesticUnitList } = action.payload;
			state.fetching = false;
			state.domesticUnitList = domesticUnitList;
		},
		getForeignDomesticUnitListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET FOREIGN DOMESTIC UNIT LIST END ---- */

		/** UPDATE OI1_01_DEFAULT_INFO_UNIT DETAIL START */
		// TODO: check it
		updateForeignDefaultInfoUnitSuccess: (
			state,
			action: PayloadAction<
				TPayloadUpdateSuccess<TGetForeignDefaultInfoUnitResponse>
			>
		) => {
			const { data } = action.payload;
			const defaultInfoUnitDetail = { ...state.defaultInfoUnitDetail };
			state.defaultInfoUnitDetail = formatForeignDefaultInfoUnitDetail(
				mergeItemUpdated<
					TForeignDefaultInfoUnitDetailStore,
					TGetForeignDefaultInfoUnitResponse
				>(defaultInfoUnitDetail, data)
			);
		},
		/** UPDATE OI1_01_DEFAULT_INFO_UNIT DETAIL END */
	},
});

export const OI1_01DefaultInfoUnitSelectors = {
	selectFetching: (state: RootState) => state.oi1_01DefaultInfoUnit.fetching,
	selectDefaultInfoUnitDetail: (state: RootState) =>
		state.oi1_01DefaultInfoUnit.defaultInfoUnitDetail,
	selectDomesticUnitList: (state: RootState) =>
		state.oi1_01DefaultInfoUnit.domesticUnitList,
};

export const OI1_01DefaultInfoUnitActions = OI1_01DefaultInfoUnitSlice.actions;
export const OI1_01DefaultInfoUnitReducer = OI1_01DefaultInfoUnitSlice.reducer;
